import React from "react"

import { ProjectHistoryOverlayView } from "./ProjectHistoryOverlayView"
import { ProjectHistoryOverlayModel } from "./model/useProjectHistoryOverlayModel"
import { useProjectHistoryOverlayViewModel } from "./model/useProjectHistoryOverlayViewModel"

export interface ProjectHistoryOverlayPayload {
  projectID: string
}

export const ProjectHistoryOverlay = React.memo(
  (props: ProjectHistoryOverlayModel) => (
    <ProjectHistoryOverlayView {...useProjectHistoryOverlayViewModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROJECT_HISTORY_OVERLAY: ProjectHistoryOverlayPayload
  }
}
